<template>
  <!-- callaction -->
  <section class="ftco-hireme">
    <div v-if="callAction != ''" class="container">
      <div class="row justify-content-between">
        <div class="col-md-8 col-lg-8 d-flex align-items-center">
          <div class="call-100 py-4">
            <h2>{{ callAction[0].itiNome }}</h2>
            <p v-html="callAction[0].itiResumo1"></p>
            <p class="mb-0">
              <RouterLink :to="callAction[0].itiLinkBtn1" class="btn btn-white py-3 px-4">{{ callAction[0].itiTextoBtn1
                }}</RouterLink>
            </p>
          </div>
        </div>
        <div class="col-md-4 col-lg-4 d-flex align-items-end justify-content-end ">
          <img :src="$imgURL + callAction[0].insInstitucionalImagens[0].itgUrlImagem" class="img-callaction hidden-xs hidden-md hidden-sm">
        </div>
      </div>
    </div>
  </section>
  <!-- END callaction -->

</template>

<script>
import axios from 'axios';

export default {
  name: 'CallAction',
  data: () => ({
    callAction: [],
    showModernizacaoMenu: false,
    return: {
      isMenuOpen: false
    }
  }),
  methods: {
    toggleModernizacaoMenu() {
      this.showModernizacaoMenu = !this.showModernizacaoMenu;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    }
  },
  created() {
    //aqui busca callaction
    axios.get('/Process/InsInstitucional/institucional/19/callaction/0/x')
      .then(response => {
        this.callAction = response.data;
        //console.log('callaction')
        //console.log(this.callAction)
      })
      .catch(error => {
        console.error(error);
      });
  }
};
</script>